import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

// You must register the locale before calling getNames.
// We register it here rather than in a nuxt/plugin because it is used in the
// store/user-info before the plugins get called
countries.registerLocale(enLocale)

const replaceAccent = (string: string) => string.replace(/Å/, 'A')

const allCountries: { [alpha2Key: string]: string } = {
  ...countries.getNames('en', { select: 'official' }),
  TW: 'Taiwan',
  CN: 'China',
  PS: 'Palestine',
  IR: 'Iran',
  SY: 'Syria',
  CD: 'Democratic Republic of the Congo',
  CG: 'Republic of the Congo',
}
const emptyOption = { value: '', label: '', attrs: { disabled: true } }

const topOptions = [
  emptyOption,
  { value: 'GBR', label: 'United Kingdom' },
  { value: 'USA', label: 'United States of America' },
  { value: 'DEU', label: 'Germany' },
  { value: 'ESP', label: 'Spain' },
  { value: 'FRA', label: 'France' },
]

export const DIVIDER = '──────────'

const divider = {
  value: DIVIDER,
  label: DIVIDER,
  attrs: { disabled: true },
}

const options = Object.entries(allCountries)
  .map(([alpha2, name]) => ({
    value: countries.alpha2ToAlpha3(alpha2) as string, // Safe to cast because we are using the official alpha2 codes
    label: name,
  }))
  .filter(
    (option) => !topOptions.map((option) => option.value).includes(option.value)
  )
  .sort((option1, option2) =>
    replaceAccent(option1.label) < replaceAccent(option2.label) ? -1 : 1
  )

export const countryOptions: {
  value: string
  label: string
  disabled?: boolean
}[] = [...topOptions, divider, ...options]
